var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"corner"},[_c('Icon',{attrs:{"type":"edit","size":"10"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }